<template>
  <section class="experts">
    <div class="experts-container">
      <div class="section-header">
        <span class="section-label">{{ t('index.experts.label') }}</span>
        <h2 class="section-title">{{ t('index.experts.title') }}</h2>
        <!-- <p class="section-desc">{{ t('index.experts.description') }}</p> -->
      </div>

      <div class="experts-grid">
        <ExpertCard
          v-for="expert in visibleExperts"
          :key="expert.name"
          :name="expert.name"
          :role="expert.role"
          :image="expert.image"
          :image-alt="expert.imageAlt"
          :webp-srcset="expert.webpSrcset"
          :bg-color="expert.bgColor"
        />
      </div>

      <div v-if="showMoreButton" class="experts-more">
        <UIButton
          variant="primary-arrow"
          arrow-direction="right"
          :text="t('blog.showMore')"
          :outline="false"
          padding="18px 34px"
          rounded="8px"
          size="large"
          @click="onShowMore"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()

const isMobile480 = ref(false)
const isExpanded = ref(false)

const BASE = '/assets/images/home-page/experts'

function expertImg(file: string) {
  return {
    image: `${BASE}/x1/${file}.jpg`,
    webpSrcset: `${BASE}/x1/webp/${file}.webp 1x, ${BASE}/x2/webp/${file}.webp 2x`,
  }
}

const experts = computed(() => [
  { name: t('index.experts.expert6Name'), role: t('index.experts.expert6Role'), ...expertImg('serhiy-vershylo-kerivnyk-shkoly-bibliyi-pastor'), imageAlt: 'Сергій Вершило — керівник Школи Біблії, пастор', bgColor: 'var(--color-avatar-beige)' },
  { name: t('index.experts.expert2Name'), role: t('index.experts.expert2Role'), ...expertImg('olena-kaminska-likar-psykhiatr'), imageAlt: 'Олена Камінська — лікар, психіатр', bgColor: 'var(--color-avatar-cyan)' },
  { name: t('index.experts.expert1Name'), role: t('index.experts.expert1Role'), ...expertImg('serhiy-serdeniuk-dyrektor-kliniky-anheliya'), imageAlt: 'Сергій Серденюк — директор клініки Ангелія', bgColor: 'var(--color-avatar-beige)' },
  { name: t('index.experts.expert4Name'), role: t('index.experts.expert4Role'), ...expertImg('yuliya-serdeniuk-likar-psykhiatr'), imageAlt: 'Юлія Серденюк — лікар, психіатр', bgColor: 'var(--color-avatar-lavender)' },
  { name: t('index.experts.expert5Name'), role: t('index.experts.expert5Role'), ...expertImg('olha-fedorchuk-likar-psykhiatr'), imageAlt: 'Ольга Федорчук — лікар, психіатр', bgColor: 'var(--color-avatar-cyan)' },
  { name: t('index.experts.expert3Name'), role: t('index.experts.expert3Role'), ...expertImg('pavlo-stepashko-viyskovyi-kapelan'), imageAlt: 'Павло Степашко — військовий капелан', bgColor: 'var(--color-avatar-mint)' },
  { name: t('index.experts.expert7Name'), role: t('index.experts.expert7Role'), ...expertImg('antonina-melnychenko-dytyachyi-psykholoh'), imageAlt: 'Антоніна Мельниченко — дитячий психолог клініки Ангелія', bgColor: 'var(--color-avatar-cyan)' },
  { name: t('index.experts.expert8Name'), role: t('index.experts.expert8Role'), ...expertImg('ivan-romaniuk-teleradioveduchyi-pastor'), imageAlt: 'Іван Романюк — телерадіоведучий, пастор', bgColor: 'var(--color-avatar-beige)' },
])

const visibleExperts = computed(() => {
  if (isMobile480.value && !isExpanded.value) return experts.value.slice(0, 4)
  return experts.value
})

const showMoreButton = computed(() => isMobile480.value && !isExpanded.value && experts.value.length > 4)

function onShowMore() {
  isExpanded.value = true
}

let mql: MediaQueryList | null = null
let onMqlChange: ((e: MediaQueryListEvent) => void) | null = null

onMounted(() => {
  mql = window.matchMedia('(max-width: 480px)')
  const apply = (matches: boolean) => {
    isMobile480.value = matches
    if (!matches) isExpanded.value = false
  }

  apply(mql.matches)
  onMqlChange = (e) => apply(e.matches)
  mql.addEventListener?.('change', onMqlChange)
})

onBeforeUnmount(() => {
  if (!mql || !onMqlChange) return
  mql.removeEventListener?.('change', onMqlChange)
})
</script>

<style scoped>
.experts {
  background-color: var(--color-bg-section);
  padding: 95px 0 50px 0;
}

.experts-container {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 10px;
  padding-bottom: 50px;
}

.experts-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 61px 24px;
}

.experts-more {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

@media (max-width: 1200px) {
  .experts-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 991px) {
  .experts {
    padding: 60px 0;
  }

  .experts-container {
    padding: 0 30px;
  }

  .experts-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px 20px;
  }
}

@media (max-width: 575px) {
  .experts-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 16px;
  }
}
@media (max-width: 480px) {
  section.experts {
    margin-top: 55px;
  }

  .experts-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 39px 16px;
  }
}
</style>

